{
	"duplicateStyleNameMessage": "A style named \"{{styleName}}\" already exists. Please choose a different name."
}
